fragment companyInfo on Company {
  id
  name
  createdAt
  updatedAt
}
